export const EVENT_TYPE_WIDGET = "widget";
export const EVENT_TYPE_PARTICIPANT = "participant";
export const EVENT_TYPE_CATEGORY = "category";


